export default (axios, vm) => {
  axios.interceptors.response.use((response) => {
    return response
  }, async (error) => {
    const originalRequest = error.config
    if (error.response.status === 401 && originalRequest.url === '/refresh') {
      vm.store.dispatch('doLogout')
      const viewerName = vm.store.getters.getViewerName
      if (vm.router.currentRoute.name !== 'Login') {
        vm.router.push('/' + viewerName + '/login')
      }
      return Promise.reject(error)
    } else if (error.response.status === 401 && (originalRequest.url === '/auth' || originalRequest.url === '/googleAuth' || originalRequest.url === '/fbAuth')) {
      return Promise.reject(error)
    } else if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const res = await axios.post('/refresh', {
          access_token: vm.store.getters.getAccessToken,
          refresh_token: vm.store.getters.getRefreshToken,
          viewerfk: vm.store.getters.getViewerId,
          appname: vm.store.getters.getViewerName,
        })
        if (res.status === 200) {
          // 1) put token to LocalStorage
          vm.store.commit('setAccessToken', res.data.token)
          vm.store.commit('setRefreshToken', res.data.refresh_token)
          const updatedUserObject = {
            loggedInUser: vm.store.getters.getLoggedInUser,
            token: res.data.token,
            refreshToken: vm.store.getters.getRefreshToken,
          }
          const vName = vm.store.getters.getViewerName
          localStorage.setItem(window.location.host + '-' + vName + '-loggedInUser', JSON.stringify(updatedUserObject))
          // 2) Change Authorization header
          originalRequest.headers.Authorization = 'Bearer ' + vm.store.getters.getAccessToken
          // 3) return originalRequest object with Axios.
          return axios(originalRequest)
        }
      } catch (nestedError) {
        console.error(nestedError)
      }
    }
    return Promise.reject(error)
  })
}
